import {useState} from "react";
import {useLocation, useOutletContext, useParams} from "react-router-dom";

import {useNavigateWithReload} from "base/hooks";
import EditIcon from "@mui/icons-material/Edit";
import {TanqueForm} from "../presentational/form";
import {SectionCardHeaderAction} from "base/component/presentational";
import {TanqueService} from "saneamiento/service";
import {tanque_view_adapter} from "saneamiento/model";
import {TanqueLocationSection} from "../presentational/section";
import {SisbagalSectionCard} from "sisbagal/auth";

const UpdateTanqueGeoPanel = () => {
    const {section} = useParams();
    const location = useLocation();
    const baseLocationPath = location.pathname.split(section)[0];

    const [mode, setMode] = useState("view");
    const [error, setError] = useState("");
    const navigate = useNavigateWithReload();

    let tanque;
    [tanque] = useOutletContext();

    const handleSubmit = tanque => {
        TanqueService.update(tanque_view_adapter({...tanque}))
            .then(() => {
                navigate(location.pathname, true);
            })
            .catch(error => {
                setError(error);
            });
    };

    const handleFormCancel = () => {
        setMode("view");
    };

    const secondaryActions = [
        <SectionCardHeaderAction
            key="edit"
            name="edit"
            text="Modificar"
            icon={<EditIcon />}
            onClick={() => {
                setMode("edit");
            }}
            roles={[]}
        />,
    ];

    return (
        <SisbagalSectionCard title="Ubicación" secondaryActions={secondaryActions}>
            {mode === "edit" ? (
                <TanqueForm
                    tanque={tanque}
                    updatedSection="geo"
                    onSubmit={handleSubmit}
                    onCancel={handleFormCancel}
                />
            ) : (
                <TanqueLocationSection tanque={tanque} />
            )}
        </SisbagalSectionCard>
    );
};

export default UpdateTanqueGeoPanel;
